import React from "react";
import "containers/Account/Onboarding/Onboarding.css";
import ProfileForm from "components/Account/Profile/ProfileForm";
import * as ProfileHelper from "components/Account/Profile/ProfileHelper";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import AxiosConfig from "axiosConfig";
import { connect } from "react-redux";
import { createChildFormData } from "components/Account/Profile/ProfileHelper";
import CustomBanner from "../../../../components/General/Form/CustomBanner";
import StripeCheckout from "react-stripe-checkout";
import axios from "axios";

class OnboardingChild extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      confirmPassword: "",
      fullName: "",
      profilePic: "",
      coverPic: "",
      dob: "",
      gender: "",
      school: "",
      schoolGrade: "",
      isTermsPrivacy: "",
      isMinorClause: "",
      isConsentSharing: "",
      isFeePay: "",
      userType: "child",
      errorMap: new Map(),
      pageError: "",
      shidden: "true",
      vhidden: "",
      buttonName: "Give Consent",
      buttonColor: "background_dark_blue",
      coverPicError: "",
      profilePicError: "",
    };
  }
  onToken = (token) => {
    axios({
      method: "post",
      headers: {
        Authorization: "Bearer "+ process.env.REACT_APP_STRIPE_KEY_SK,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      url: "https://api.stripe.com/v1/charges",
      data:
        "amount=100&currency=usd&source=" +
        token.id +
        "&description=Katamundi - Verifiable Parental Consent",
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            shidden: "",
            vhidden: "true",
          });
        }
      })
      .catch((res) => {
        this.setState({
          buttonName: "Retry payment method",
          buttonColor: "background_red",
        });
      });
  };

  createChildAxiosCall(condition) {
    let obj = this;
    let formData = createChildFormData(obj);
    AxiosConfig.post("/account/addchild/", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then(function (response) {
        if (response.data["status"] === "SUCCESS") {
          let userList = JSON.parse(sessionStorage.getItem("userList"));
          userList.push(response.data["child_data"]);
          sessionStorage.setItem("userList", JSON.stringify(userList));
          if (condition === "next") {
            obj.landUserAccount();
          } else if (condition === "more") {
            obj.props.history.push(`/onboarding-add-child`);
            // window.scrollTo(0, 0);
            window.location.reload();
          }
        }
      })
      .catch(function (error) {
        obj.setState({ pageError: "Validation Error" });
      });
  }

  onSaveClicked(event) {
    event.preventDefault();
    ProfileHelper.addChildDetails.bind(this)("next");
  }

  onSaveAddMoreClicked(event) {
    event.preventDefault();
    ProfileHelper.addChildDetails.bind(this)("more");
  }

  landUserAccount() {
    this.props.dispatch({ type: "LOGIN_SUCCESS" });
    this.props.history.push(`/projects`);
  }
  onSkipClicked(event) {
    event.preventDefault();
    this.landUserAccount();
  }

  render() {
    return (
      <div>
        <CustomBanner message="Add children to your family account." />
        <div className="onboarding_content" style={{ flexGrow: "1" }}>
          {
            <ProfileForm
              onboarding={true}
              username={this.state.username}
              password={this.state.password}
              confirmPassword={this.state.confirmPassword}
              fullName={this.state.fullName}
              dob={this.state.dob}
              gender={this.state.gender}
              profilePic={this.state.profilePic}
              coverPic={this.state.coverPic}
              school={this.state.school}
              schoolGrade={this.state.schoolGrade}
              userType={this.state.userType}
              isTermsPrivacy={this.state.isTermsPrivacy}
              isMinorClause={this.state.isMinorClause}
              isConsentSharing={this.state.isConsentSharing}
              isFeePay={this.state.isFeePay}
              errorMap={this.state.errorMap}
              onDataChange={ProfileHelper.onDataChange.bind(this)}
              onCheckboxChange={ProfileHelper.onCheckboxChange.bind(this)}
              onCoverImageChange={ProfileHelper.onCoverImageChange.bind(this)}
              onImageChange={ProfileHelper.onImageChange.bind(this)}
              onSaveClicked={this.onSaveClicked.bind(this)}
              onProjectInterestDataChange={ProfileHelper.onProjectInterestDataChange.bind(
                this
              )}
              coverPicError={this.state.coverPicError}
              profilePicError={this.state.profilePicError}
            />
          }
          {this.state.pageError ? (
            <div className="text_red text-center">
              <br />
              {this.state.pageError}
              <br />
              <br />
            </div>
          ) : (
            null
          )}
          {/* form ends here */}
          <div className="onboarding_button_options">
            <RoundedButton
              title="Skip for now, maybe later."
              buttonClassName="background_white"
              textThemeClassName="text_medium text_dark_orange"
              handleOnClick={this.onSkipClicked.bind(this)}
            />
            <RoundedButton
              title="&nbsp;&nbsp;&nbsp;Save and add more child&nbsp;&nbsp;&nbsp;"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick={this.onSaveAddMoreClicked.bind(this)}
              hidden={this.state.shidden}
              margin="0px 5px 0px 0px"
            />
            <RoundedButton
              title="&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick={this.onSaveClicked.bind(this)}
              hidden={this.state.shidden}
            />
            <StripeCheckout
              name="Katamundi"
              description="Pay $1 to complete registration."
              label="Pay"
              token={this.onToken}
              shippingAddress={false}
              billingAddress={false}
              amount={100}
              stripeKey={process.env.REACT_APP_STRIPE_KEY_PK}
            >
              <RoundedButton
                title={this.state.buttonName}
                buttonClassName="background_dark_orange"
                textThemeClassName="text_medium text_white"
                hidden={this.state.vhidden}
              />
            </StripeCheckout>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(OnboardingChild);
